export const JobVacancyConstants = {
  OTHER_ID: 8,
  FHP_EMPLOYEE_ID: 13,
}
